// extracted by mini-css-extract-plugin
export var banner = "_3e-0";
export var icon = "_3e-1";
export var message = "_3e-2";